import { Component, OnInit } from '@angular/core';
import {
  NavigationItem,
  navigationItemsInvoices,
} from '../../models/navigation-item-model';
import { classes, pages } from '../../shared/labels';
import { SharedModule } from '../../shared/shared.module';

import { Router } from '@angular/router';
import { LabelService } from '../../services/label.service';
import {
  InvoiceCompanyClient,
  InvoiceNextDraftNumber,
  InvoicePrivateClient,
  NewInvoice,
  StatoFatturaSTS,
  TableInvoiceFields,
} from '../../models/invoices';
import { StsExpense } from './invoices-sts/sts-models';
import { InvoicesService } from '../../services/invoices.service';
import { ErrorPanelService } from '../../services/error-panel.service';
import { InvoicesNotificationPanelComponent } from './invoices-notification-panel/invoices-notification-panel.component';
import { MatIconModule } from '@angular/material/icon';
import { InvoicesInfoPanelComponent } from './invoices-info-panel/invoices-info-panel.component';
import { PanelCreateModifyInvoiceSdiComponent } from './panels-create-modify-invoices/panel-create-modify-invoice-sdi/panel-create-modify-invoice-sdi.component';
import { InvoicesPanelModifyPaymentDateComponent } from './invoices-panel-modify-payment-date/invoices-panel-modify-payment-date.component';
import { ExpenseCreateResponse } from '../../models/api/responses/invoices-sts.response';
import { GmailService } from '../../services/gmail.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CalendarUtilsService } from '../calendar-page/calendar-utils.service';
import { StsExpenseService } from './invoices-sts/sts-expense.service';
import { StsCreditNoteService } from './invoices-sts/sts-credit-note.service';

@Component({
  selector: 'app-invoices-page',
  standalone: true,
  imports: [
    SharedModule,
    InvoicesNotificationPanelComponent,
    InvoicesInfoPanelComponent,
    InvoicesPanelModifyPaymentDateComponent,
    MatIconModule,
    PanelCreateModifyInvoiceSdiComponent,
    MatTooltipModule,
  ],
  templateUrl: './invoices-page.component.html',
  styleUrl: './invoices-page.component.scss',
})
export class InvoicesPageComponent implements OnInit {
  navigationItems: NavigationItem[];
  invoices: TableInvoiceFields[] = [];
  sdiInvoices: TableInvoiceFields[] = [];
  stsInvoices: TableInvoiceFields[] = [];
  showNewInvoicePanel: boolean = false;
  showCreateModifyInvoiceSDIPanel: boolean = false;
  showCreateModifyDraftSTSPanel: boolean = false;
  showPreviewInvoicePanel: boolean = false;
  showNotificationsPanel: boolean = false;
  selectedInvoice: TableInvoiceFields | null = null;
  areSDIBillingDataCorrect: boolean = true;
  areSTSBillingDataCorrect: boolean = true;

  newInvoicePanelTitle: string = 'Nuova Fattura';
  isEditMode: boolean = false;

  isLoadingInvoices: boolean = true;
  isLoadingSDIInvoices: boolean = true;
  isLoadingSTSInvoices: boolean = true;
  showInfoPanel: boolean = false;
  showPaymentDatePanel: boolean = false;

  doctorSTSErrorFields: string = '';
  doctorSDIErrorFields: string = '';

  constructor(
    private router: Router,
    public labelService: LabelService,
    private invoicesService: InvoicesService,
    private errorService: ErrorPanelService,
    private gmailService: GmailService,
    private calendarUtilsService: CalendarUtilsService,
    private stsExpenseService: StsExpenseService,
    private stsCreditNoteService: StsCreditNoteService
  ) {
    // highlight the correct page in the side bar
    this.navigationItems = navigationItemsInvoices.map((item) => {
      if (item.label === pages.invoices_list) {
        return { ...item, class: classes.hnb };
      }
      return { ...item };
    });
  }
  ngOnInit(): void {
    this.validateDoctorBillingData();
  }

  validateDoctorBillingData() {
    this.invoicesService.validateDoctorBillingData().subscribe({
      next: (res) => {
        if (res.sts_error_description) {
          this.doctorSTSErrorFields = res.sts_error_description;
          console.log(this.doctorSTSErrorFields, 'STS');
        }
        if (res.sdi_error_description) {
          this.doctorSDIErrorFields = res.sdi_error_description;
          console.log(this.doctorSDIErrorFields, 'SDI');
        }
        if (res.sts_valid) {
          this.getSTSInvoices();
          this.areSTSBillingDataCorrect = true;
        } else {
          this.areSTSBillingDataCorrect = false;
          this.isLoadingSTSInvoices = false;
        }
        if (res.sdi_valid) {
          this.getSDIInvoices();
          this.areSDIBillingDataCorrect = true;
        } else {
          this.areSDIBillingDataCorrect = false;
          this.isLoadingSDIInvoices = false;
        }
        this.isLoadingInvoices =
          this.isLoadingSDIInvoices && this.isLoadingSTSInvoices;
      },
      error: (err) => {
        console.error(
          'Errore nella validazione dei dati di fatturazione.',
          err
        );
        this.errorService.showErrorSnackBar(
          'Errore nella validazione dei dati di fatturazione.'
        );
      },
    });
  }

  getInvoices() {
    this.getSTSInvoices();
    this.getSDIInvoices();
  }

  getSTSInvoices() {
    this.invoicesService.getSTSInvoices().subscribe({
      next: (res) => {
        this.stsInvoices = res;
        this.sortInvoices();
        this.isLoadingSTSInvoices = false;
        this.isLoadingInvoices =
          this.isLoadingSDIInvoices && this.isLoadingSTSInvoices;
      },
      error: (err) => {
        console.error('Errore nel caricare le fatture STS', err);
        this.errorService.showErrorSnackBar(
          'Errore nel caricare le fatture STS. '
        );
        this.isLoadingSTSInvoices = false;
        this.isLoadingInvoices =
          this.isLoadingSDIInvoices && this.isLoadingSTSInvoices;
      },
    });
  }

  getSDIInvoices() {
    this.invoicesService.getSDIInvoices().subscribe({
      next: (res) => {
        this.sdiInvoices = res;
        this.sortInvoices();
        this.isLoadingSDIInvoices = false;
        this.isLoadingInvoices =
          this.isLoadingSDIInvoices && this.isLoadingSTSInvoices;
      },
      error: (err) => {
        console.error('Errore nel caricare le fatture SDI.', err);
        this.errorService.showErrorSnackBar(
          'Errore nel caricare le fatture SDI.'
        );
        this.isLoadingSDIInvoices = false;
        this.isLoadingInvoices =
          this.isLoadingSDIInvoices && this.isLoadingSTSInvoices;
      },
    });
  }

  sortInvoices() {
    this.invoices = [...this.stsInvoices, ...this.sdiInvoices];
    this.invoices.sort((a, b) => {
      // Convert dd/mm/yyyy to Date objects for comparison
      const [dayA, monthA, yearA] = a.data.split('/').map(Number);
      const [dayB, monthB, yearB] = b.data.split('/').map(Number);
      const dateA = new Date(yearA, monthA - 1, dayA);
      const dateB = new Date(yearB, monthB - 1, dayB);

      // Compare dates first
      if (dateA.getTime() !== dateB.getTime()) {
        return dateB.getTime() - dateA.getTime(); // Most recent dates first
      }

      // If dates are equal, compare progressivo_numero
      return parseInt(b.progressivo_numero) - parseInt(a.progressivo_numero);
    });
  }

  toggleModifyDraftPanel(selectedInvoice: TableInvoiceFields) {
    switch (selectedInvoice.tipo) {
      case 'Parcella Privati':
        this.stsExpenseService.clear();
        this.router.navigate(['/fatture/sts', selectedInvoice.id]);
        break;
      case 'Parcella SDI':
      case 'Nota di Credito SDI':
        this.toggleCreateModifyInvoiceSDIPanel(selectedInvoice);
        break;
    }
  }

  toggleCreateModifyInvoiceSDIPanel(selectedInvoice?: TableInvoiceFields) {
    this.showCreateModifyInvoiceSDIPanel =
      !this.showCreateModifyInvoiceSDIPanel;
    if (selectedInvoice) {
      this.selectedInvoice = selectedInvoice;
      this.newInvoicePanelTitle = 'Modifica Fattura SDI';
    } else {
      this.selectedInvoice = null;
      this.newInvoicePanelTitle = 'Nuova Fattura SDI';
    }
  }

  navigateToNewSts(): void {
    this.stsExpenseService.clear();
    this.router.navigate(['/fatture/sts']);
  }

  redirectToDoctorPage() {
    this.router.navigate(['/area-personale']);
  }

  createInvoiceSDIDraft(data: NewInvoice, action?: string) {
    this.invoicesService.createInvoiceSDIDraft(data).subscribe({
      next: (res) => {
        if (action !== 'duplicate') {
          this.toggleCreateModifyInvoiceSDIPanel();
        }
        this.getSDIInvoices();
        this.errorService.showInfoSnackBar(
          `Fattura ${data.progressivo_numero} salvata con successo in stato bozza.`
        );
      },
      error: (err) => {
        console.error(err);
        this.errorService.showErrorSnackBar(
          'Errore nella creazione della fattura.'
        );
      },
    });
  }

  createInvoiceSDIReady(data: NewInvoice) {
    this.invoicesService.createInvoiceSDIReady(data).subscribe({
      next: (res) => {
        if (res.status === 'partial_success') {
          this.errorService.showErrorSnackBar(
            'La Fattura è stata creata in Bozza perchè ci sono stati dei problemi di validazione.'
          );
        }
        this.toggleCreateModifyInvoiceSDIPanel();
        this.getSDIInvoices();
        this.errorService.showInfoSnackBar(
          `Fattura ${data.progressivo_numero} salvata con successo in stato pronta.`
        );
      },
      error: (err) => {
        console.error(err);
        this.errorService.showErrorSnackBar(
          'Errore nella creazione della fattura.'
        );
      },
    });
  }

  promoteDraftInvoiceSDIToReady(data: NewInvoice) {
    this.invoicesService
      .promoteDraftInvoiceSDIToReady(this.selectedInvoice?.id || '', data)
      .subscribe({
        next: (res) => {
          if (res.status === 'partial_success') {
            this.errorService.showErrorSnackBar(
              'La Fattura è stata salvata in Bozza perchè ci sono stati dei problemi di validazione.'
            );
          }
          this.toggleCreateModifyInvoiceSDIPanel();
          this.getSDIInvoices();
          this.errorService.showInfoSnackBar(
            `Fattura ${data.progressivo_numero} modificata con successo in stato pronta.`
          );
        },
        error: (err) => {
          console.error(err);
          this.errorService.showErrorSnackBar(
            'Errore nella modifica della fattura.'
          );
        },
      });
  }

  viewStsSummaryFromList(invoice: TableInvoiceFields) {
    this.stsExpenseService.clear();
    this.router.navigate(['/fatture/sts', invoice.id, 'riepilogo']);
  }

  issueStsCreditNoteFromList(invoice: TableInvoiceFields) {
    this.stsCreditNoteService.setSource(invoice);
    this.router.navigate(['/fatture/nota-di-credito-sts']);
  }

  promoteStsDraftToReadyFromList(invoice: TableInvoiceFields) {
    this.invoicesService.promoteDraftInvoiceSTSToReady(invoice.id).subscribe({
      next: () => {
        this.getSTSInvoices();
        this.errorService.showInfoSnackBar(
          `Spesa ${invoice.progressivo_numero} modificata con successo in stato pronta.`
        );
      },
      error: (err) => {
        console.error(err);
        this.errorService.showErrorSnackBar(
          'Errore nella promozione della spesa.'
        );
      },
    });
  }

  modifyInvoiceSDIDraft(data: NewInvoice) {
    this.invoicesService
      .modifyInvoiceSDIDraft(this.selectedInvoice?.id || '', data)
      .subscribe({
        next: (res) => {
          this.toggleCreateModifyInvoiceSDIPanel();
          this.getSDIInvoices();
          this.errorService.showInfoSnackBar(
            `Fattura in bozza ${data.progressivo_numero} modificata con successo.`
          );
        },
        error: (err) => {
          console.error(err);
          this.errorService.showErrorSnackBar(
            'Errore nella modifica della fattura.'
          );
        },
      });
  }

  deleteInvoice(invoice: TableInvoiceFields) {
    switch (invoice.tipo) {
      case 'Parcella Privati':
        if (invoice.stato === StatoFatturaSTS.BOZZA) {
          this.invoicesService.deleteInvoiceSTSDraft(invoice.id).subscribe({
            next: (res) => {
              this.getSTSInvoices();
              this.errorService.showInfoSnackBar(
                `La spesa STS ${invoice.progressivo_numero} è stata cancellata con successo.`
              );
            },
            error: (err) => {
              console.error(err);
              this.errorService.showErrorSnackBar(
                "Errore nell'eliminazione della fattura."
              );
            },
          });
        } else {
          this.invoicesService.deleteInvoiceSTS(invoice.id).subscribe({
            next: (res) => {
              this.getSTSInvoices();
              this.errorService.showInfoSnackBar(
                `La fattura ${invoice.progressivo_numero} è stata cancellata con successo.`
              );
            },
            error: (err) => {
              console.error(err);
              this.errorService.showErrorSnackBar(
                "Errore nell'eliminazione della fattura."
              );
            },
          });
        }
        break;
      case 'Parcella SDI':
        this.invoicesService.deleteInvoiceSDIDraft(invoice.id).subscribe({
          next: (res) => {
            this.getSDIInvoices();
          },
          error: (err) => {
            console.error(err);
            this.errorService.showErrorSnackBar(
              "Errore nell'eliminazione della fattura."
            );
          },
        });
        break;
    }
  }

  sendInvoice(invoice: TableInvoiceFields) {
    switch (invoice.tipo) {
      case 'Parcella Privati':
        this.sendInvoiceToSTS(invoice);
        break;
      case 'Nota di Credito SDI':
      case 'Parcella SDI':
        this.sendInvoiceToSDI(invoice);
        break;
    }
  }

  sendInvoiceToSTS(invoice: TableInvoiceFields) {
    // TODO: make sure that everytime that acube returns an error code (400, 500, etc) this information
    // is caught in the 'error' block, and not in the 'next' block.
    this.invoicesService.sendSTSInvoice(invoice.id).subscribe({
      next: (res: ExpenseCreateResponse) => {
        if (res.error) {
          this.errorService.showErrorSnackBar(res.error.detail);
        } else {
          this.getSTSInvoices();
          this.errorService.showInfoSnackBar(
            'La fattura è stata inviata con successo a STS.'
          );
        }
      },
      error: (err) => {
        if (err.error.detail) {
          this.errorService.showErrorSnackBar(err.error.detail);
        } else {
          this.errorService.showErrorSnackBar(
            "Errore nell'invio della fattura."
          );
        }
      },
    });
  }

  sendInvoiceToSDI(invoice: TableInvoiceFields) {
    this.invoicesService.sendSDIInvoice(invoice.id).subscribe({
      next: (res) => {
        this.getSDIInvoices();
        this.errorService.showInfoSnackBar(
          'La fattura è stata inviata con successo a SDI.'
        );
      },
      error: (err) => {
        console.error(err);
        this.errorService.showErrorSnackBar("Errore nell'invio della fattura.");
      },
    });
  }

  duplicateInvoice(invoice: TableInvoiceFields) {
    switch (invoice.tipo) {
      case 'Parcella Privati':
        this.duplicateInvoiceToSTS(invoice);
        break;
      case 'Parcella SDI':
        this.duplicateInvoiceToSDI(invoice);
        break;
    }
  }

  duplicateInvoiceToSTS(invoice: TableInvoiceFields) {
    this.invoicesService.getSTSInvoiceById(invoice.id).subscribe({
      next: (res) => {
        const duplicateInvoice: StsExpense = { ...res };
        delete duplicateInvoice.id;
        if (duplicateInvoice.pagata) {
          duplicateInvoice.pagata = false;
        }
        if (duplicateInvoice.data_pagamento) {
          duplicateInvoice.data_pagamento = undefined;
        }
        if (duplicateInvoice.data) {
          duplicateInvoice.data =
            this.calendarUtilsService.getTodayStringDate();
        }
        this.invoicesService.getSTSNextNumber().subscribe({
          next: (res: InvoiceNextDraftNumber) => {
            duplicateInvoice.progressivo_numero = res.progressivo_numero;
            duplicateInvoice.progressivo_anno = res.progressivo_anno;
            this.invoicesService
              .createInvoiceSTSDraft(duplicateInvoice)
              .subscribe({
                next: (res) => {
                  this.getSTSInvoices();
                  this.errorService.showInfoSnackBar(
                    `Spesa ${duplicateInvoice.progressivo_numero} salvata con successo in stato bozza.`
                  );
                },
                error: (err) => {
                  this.errorService.showErrorSnackBar(
                    'Errore nella duplicazione della spesa.'
                  );
                },
              });
          },
          error: (err) => {
            console.error(err);
            this.errorService.showErrorSnackBar(
              'Errore nella duplicazione della spesa.'
            );
          },
        });
      },
      error: (err) => {
        console.error(err);
        this.errorService.showErrorSnackBar(
          'Errore nella duplicazione della spesa.'
        );
      },
    });
  }

  duplicateInvoiceToSDI(invoice: TableInvoiceFields) {
    this.invoicesService.getSDIInvoiceById(invoice.id).subscribe({
      next: (res) => {
        let duplicateInvoice: NewInvoice = res;
        if ('id' in duplicateInvoice) {
          delete duplicateInvoice.id;
        }
        if (duplicateInvoice.pagata) {
          duplicateInvoice.pagata = false;
        }
        if (duplicateInvoice.data_pagamento) {
          duplicateInvoice.data_pagamento = undefined;
        }
        if (duplicateInvoice.data) {
          duplicateInvoice.data =
            this.calendarUtilsService.getTodayStringDate();
        }
        this.invoicesService.getSDINextNumber().subscribe({
          next: (res: InvoiceNextDraftNumber) => {
            duplicateInvoice.progressivo_numero = res.progressivo_numero;
            duplicateInvoice.progressivo_anno = res.progressivo_anno;
            this.createInvoiceSDIDraft(duplicateInvoice, 'duplicate');
          },
          error: (err) => {
            console.error(err, 'AAAA');
          },
        });
      },
      error: (err) => {
        console.error(err, 'AAAA');
      },
    });
  }

  toggleNotificationsPanel(invoice?: TableInvoiceFields) {
    this.showNotificationsPanel = !this.showNotificationsPanel;
    if (invoice) {
      this.selectedInvoice = invoice;
    } else {
      this.selectedInvoice = null;
    }
  }

  onPagataChange(
    event: { invoice: TableInvoiceFields; checked: boolean },
    newPaymentDate?: string
  ) {
    //event.invoice.pagata = event.checked;
    let payload = {
      pagata: event.checked,
      data_pagamento: null as string | null,
    };
    if (event.checked) {
      payload.data_pagamento = event.invoice.data;
    }
    if (newPaymentDate) {
      payload.data_pagamento = newPaymentDate;
    }
    switch (event.invoice.tipo) {
      case 'Parcella Privati':
        this.invoicesService
          .modifyInvoiceSTSPagata(event.invoice.id, payload)
          .subscribe({
            next: (res) => {
              console.log('Pagata modificata');
              this.stsInvoices.find((invoice) => {
                if (invoice.id === event.invoice.id) {
                  invoice.pagata = event.checked;
                  invoice.data_pagamento = payload.data_pagamento || '';
                }
              });
            },
            error: (err) => {
              console.error(err, 'Errore nella modifica della fattura.');
              this.errorService.showErrorSnackBar(
                'Errore nella modifica della fattura.'
              );
            },
          });
        break;
      case 'Nota di credito SDI':
      case 'Parcella SDI':
        this.invoicesService
          .modifyInvoiceSDIPagata(event.invoice.id, payload)
          .subscribe({
            next: (res) => {
              console.log('Pagata modificata');
              this.sdiInvoices.find((invoice) => {
                if (invoice.id === event.invoice.id) {
                  invoice.pagata = event.checked;
                  invoice.data_pagamento = payload.data_pagamento || '';
                }
              });
            },
            error: (err) => {
              console.error(err, 'Errore nella modifica della fattura.');
              this.errorService.showErrorSnackBar(
                'Errore nella modifica della fattura.'
              );
            },
          });
        break;
    }
  }

  toggleInvoicePaymentDatePanel(invoice?: TableInvoiceFields) {
    this.showPaymentDatePanel = !this.showPaymentDatePanel;
    if (invoice) {
      this.selectedInvoice = invoice;
    } else {
      this.selectedInvoice = null;
    }
  }

  downloadInvoiceSTSPDF(invoice: TableInvoiceFields) {
    this.invoicesService.downloadInvoiceSTSPDF(invoice.id).subscribe({
      next: (blob: Blob) => {
        const url = window.URL.createObjectURL(blob);
        window.open(url, '_blank');
        const link = document.createElement('a');
        link.href = url;
        link.download = `parcella_${invoice.progressivo_anno}_${invoice.progressivo_numero}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      },
      error: (error) => {
        console.error('Error downloading PDF:', error);
        this.errorService.showErrorSnackBar(
          'Errore durante il download del PDF della spesa.'
        );
      },
    });
  }
  downloadInvoiceSDIPDF(invoice: TableInvoiceFields) {
    this.invoicesService.downloadInvoiceSDIPDF(invoice.id).subscribe({
      next: (blob: Blob) => {
        const url = window.URL.createObjectURL(blob);
        window.open(url, '_blank');
        const link = document.createElement('a');
        link.href = url;
        link.download = `parcella_${invoice.progressivo_anno}_${invoice.progressivo_numero}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      },
      error: (error) => {
        console.error('Error downloading PDF:', error);
        this.errorService.showErrorSnackBar(
          'Errore durante il download del PDF della fattura.'
        );
      },
    });
  }
  sendEmailToClientDispatcher(invoice: TableInvoiceFields) {
    switch (invoice.tipo) {
      case 'Parcella Privati':
        this.sendEmailSTSToClient(invoice);
        break;
      case 'Parcella SDI':
        this.sendEmailSDIToClient(invoice);
        break;
    }
  }

  sendEmailSTSToClient(invoice: TableInvoiceFields) {
    this.invoicesService.getPrivateClient(invoice.client_id).subscribe({
      next: (privateClient: InvoicePrivateClient) => {
        if (!privateClient.client_email || privateClient.client_email === '') {
          this.errorService.showErrorSnackBar(
            `Il cliente ${privateClient.client_first_name} ${privateClient.client_last_name} non ha un indirizzo email valido.`
          );
          return;
        }
        // First get the PDF
        this.invoicesService.downloadInvoiceSTSPDF(invoice.id).subscribe({
          next: (pdfBlob: Blob) => {
            // Prepare email content
            const subject = `Fattura ${invoice.progressivo_numero} del ${invoice.data}`;
            const body = `Gentile Cliente,\n\nIn allegato trova la fattura ${invoice.progressivo_numero} del ${invoice.data}.\n\nCordiali saluti`;

            // Send email with PDF attachment
            this.gmailService
              .sendEmailWithPDFAttachment(
                privateClient.client_email,
                subject,
                body,
                pdfBlob
              )
              .subscribe({
                next: () => {
                  this.errorService.showInfoSnackBar(
                    'Email inviata con successo al cliente.'
                  );
                },
                error: (err) => {
                  console.error('Error sending email:', err);
                  this.errorService.showErrorSnackBar(
                    "Errore nell'invio dell'email al cliente."
                  );
                },
              });
          },
          error: (err) => {
            console.error('Error downloading PDF:', err);
            this.errorService.showErrorSnackBar(
              'Errore nel recupero del PDF della fattura.'
            );
          },
        });
      },
      error: (err) => {
        this.errorService.showErrorSnackBar(
          'Errore nel recupero della mail del cliente.'
        );
      },
    });
  }

  sendEmailSDIToClient(invoice: TableInvoiceFields) {
    this.invoicesService.getCompanyClient(invoice.client_id).subscribe({
      next: (companyClient: InvoiceCompanyClient) => {
        if (!companyClient.email || companyClient.email === '') {
          this.errorService.showErrorSnackBar(
            `Il cliente ${companyClient.company_name} non ha un indirizzo email valido.`
          );
          return;
        }
        // First get the PDF
        this.invoicesService.downloadInvoiceSDIPDF(invoice.id).subscribe({
          next: (pdfBlob: Blob) => {
            // Prepare email content
            const subject = `Fattura ${invoice.progressivo_numero} del ${invoice.data}`;
            const body = `Gentile Cliente,\n\nIn allegato trova la fattura ${invoice.progressivo_numero} del ${invoice.data}.\n\nCordiali saluti`;

            // Send email with PDF attachment
            this.gmailService
              .sendEmailWithPDFAttachment(
                companyClient.email,
                subject,
                body,
                pdfBlob
              )
              .subscribe({
                next: () => {
                  this.errorService.showInfoSnackBar(
                    'Email inviata con successo al cliente.'
                  );
                },
                error: (err) => {
                  console.error('Error sending email:', err);
                  this.errorService.showErrorSnackBar(
                    "Errore nell'invio dell'email al cliente."
                  );
                },
              });
          },
          error: (err) => {
            console.error('Error downloading PDF:', err);
            this.errorService.showErrorSnackBar(
              'Errore nel recupero del PDF della fattura.'
            );
          },
        });
      },
      error: (err) => {
        this.errorService.showErrorSnackBar(
          'Errore nel recupero della mail del cliente.'
        );
      },
    });
  }

  revertInvoiceToBozzaDispatcher(invoice: TableInvoiceFields) {
    switch (invoice.tipo) {
      case 'Parcella Privati':
        this.revertInvoiceSTSToBozza(invoice);
        break;
      case 'Parcella SDI':
        this.retrocedeInvoiceSDIToBozza(invoice);
        break;
    }
  }

  revertInvoiceSTSToBozza(invoice: TableInvoiceFields) {
    this.invoicesService.revertInvoiceSTSToBozza(invoice.id).subscribe({
      next: () => {
        this.errorService.showInfoSnackBar(
          `La fattura ${invoice.progressivo_numero} è stata retrocessa a bozza con successo.`
        );
        this.getSTSInvoices();
      },
      error: (err) => {
        this.errorService.showErrorSnackBar(
          `Errore nella retrocessione della fattura ${invoice.progressivo_numero} a bozza.`
        );
      },
    });
  }

  retrocedeInvoiceSDIToBozza(invoice: TableInvoiceFields) {
    this.invoicesService.retrocedeInvoiceSDIToBozza(invoice.id).subscribe({
      next: () => {
        this.errorService.showInfoSnackBar(
          `La fattura ${invoice.progressivo_numero} è stata retrocessa a bozza con successo.`
        );
        this.getSDIInvoices();
      },
      error: (err) => {
        this.errorService.showErrorSnackBar(
          `Errore nella retrocessione della fattura ${invoice.progressivo_numero} a bozza.`
        );
      },
    });
  }

  onConfirmNewPaymentDate(newPaymentDate: string) {
    this.onPagataChange(
      {
        invoice: this.selectedInvoice as TableInvoiceFields,
        checked: true,
      },
      newPaymentDate
    );
    this.toggleInvoicePaymentDatePanel();
  }

  toggleInfoPanel() {
    this.showInfoPanel = !this.showInfoPanel;
  }

  deleteInvoicesDispatcher(event: {
    type: 'private' | 'sdi';
    invoices: TableInvoiceFields[];
  }) {
    switch (event.type) {
      case 'private':
        this.deleteInvoicesSTS(event.invoices);
        break;
      case 'sdi':
        this.deleteInvoicesSDI(event.invoices);
        break;
    }
  }
  deleteInvoicesSTS(invoices: TableInvoiceFields[]) {
    const deletePromises = invoices.map(
      (invoice) =>
        new Promise<void>((resolve) => {
          this.invoicesService.deleteInvoiceSTSDraft(invoice.id).subscribe({
            next: () => {
              console.log(
                `Invoice ${invoice.progressivo_numero} deleted successfully`
              );
              resolve();
            },
            error: (err) => {
              console.error(
                `Error deleting invoice ${invoice.progressivo_numero}:`,
                err
              );
              this.errorService.showErrorSnackBar(
                `Errore nell'eliminazione della fattura ${invoice.progressivo_numero}`
              );
              resolve(); // Still resolve to allow other operations to complete
            },
          });
        })
    );

    Promise.all(deletePromises).then(() => {
      this.getSTSInvoices(); // Refresh after all operations complete
    });
  }

  deleteInvoicesSDI(invoices: TableInvoiceFields[]) {
    const deletePromises = invoices.map(
      (invoice) =>
        new Promise<void>((resolve) => {
          this.invoicesService.deleteInvoiceSDIDraft(invoice.id).subscribe({
            next: () => {
              console.log(
                `Invoice ${invoice.progressivo_numero} deleted successfully`
              );
              resolve();
            },
            error: (err) => {
              console.error(
                `Error deleting invoice ${invoice.progressivo_numero}:`,
                err
              );
              this.errorService.showErrorSnackBar(
                `Errore nell'eliminazione della fattura ${invoice.progressivo_numero}`
              );
              resolve(); // Still resolve to allow other operations to complete
            },
          });
        })
    );

    Promise.all(deletePromises).then(() => {
      this.getSDIInvoices(); // Refresh after all operations complete
    });
  }

  sendInvoicesDispatcher(event: {
    type: 'private' | 'sdi';
    invoices: TableInvoiceFields[];
  }) {
    switch (event.type) {
      case 'private':
        this.sendInvoicesSTS(event.invoices);
        break;
      case 'sdi':
        this.sendInvoicesSDI(event.invoices);
        break;
    }
  }

  sendInvoicesSTS(invoices: TableInvoiceFields[]) {
    const sendPromises = invoices.map(
      (invoice) =>
        new Promise<void>((resolve) => {
          this.invoicesService.sendSTSInvoice(invoice.id).subscribe({
            next: () => {
              console.log(
                `Invoice ${invoice.progressivo_numero} sent successfully`
              );
              resolve();
            },
            error: (err) => {
              console.error(
                `Error sending invoice ${invoice.progressivo_numero}:`,
                err
              );
              this.errorService.showErrorSnackBar(
                `Errore nell'invio della fattura ${invoice.progressivo_numero}`
              );
              resolve(); // Still resolve to allow other operations to complete
            },
          });
        })
    );

    Promise.all(sendPromises).then(() => {
      this.getSTSInvoices(); // Refresh after all operations complete
    });
  }

  sendInvoicesSDI(invoices: TableInvoiceFields[]) {
    const sendPromises = invoices.map(
      (invoice) =>
        new Promise<void>((resolve) => {
          this.invoicesService.sendSDIInvoice(invoice.id).subscribe({
            next: () => {
              console.log(
                `Invoice ${invoice.progressivo_numero} sent successfully`
              );
              resolve();
            },
            error: (err) => {
              console.error(
                `Error sending invoice ${invoice.progressivo_numero}:`,
                err
              );
              this.errorService.showErrorSnackBar(
                `Errore nell'invio della fattura ${invoice.progressivo_numero}`
              );
              resolve(); // Still resolve to allow other operations to complete
            },
          });
        })
    );

    Promise.all(sendPromises).then(() => {
      this.getSDIInvoices(); // Refresh after all operations complete
    });
  }

  getReceipt(invoice: TableInvoiceFields) {
    this.invoicesService.getReceipt(invoice.id).subscribe({
      next: (pdfBlob: Blob) => {
        // Create a URL for the PDF blob
        const pdfUrl = URL.createObjectURL(pdfBlob);

        // Open the PDF in a new tab
        window.open(pdfUrl, '_blank');

        // Clean up the URL object after a delay
        setTimeout(() => URL.revokeObjectURL(pdfUrl), 30000);
      },
      error: (err) => {
        console.error('Error getting receipt:', err);
        this.errorService.showErrorSnackBar(
          'Errore nel recupero della ricevuta.'
        );
      },
    });
  }
}
